import { render, staticRenderFns } from "./DescriptionTab.vue?vue&type=template&id=7e15ef36&scoped=true"
import script from "./DescriptionTab.vue?vue&type=script&lang=js"
export * from "./DescriptionTab.vue?vue&type=script&lang=js"
import style0 from "./DescriptionTab.vue?vue&type=style&index=0&id=7e15ef36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e15ef36",
  null
  
)

export default component.exports